module.exports = __webpack_public_path__ + "img/icon-customer.20132df5.svg";